module.exports = __webpack_public_path__ + "static/Flyers-ab754337bb3bef8efcdcd65ac7c0f107.svg";